/**
 * FAQ Accordion Module
 * 
 * @package KateMedia
 */

export function initFaqAccordion() {
    const faqQuestions = document.querySelectorAll('.faq__question');
    
    if (faqQuestions.length === 0) {
        return;
    }
    
    const firstItem = document.querySelector('.faq__item--active');
    if (firstItem) {
        const firstAnswer = firstItem.querySelector('.faq__answer');
        if (firstAnswer) {
            firstAnswer.style.maxHeight = firstAnswer.scrollHeight + 'px';
        }
    }
    
    faqQuestions.forEach(question => {
        question.addEventListener('click', function() {
            const item = this.closest('.faq__item');
            const answer = item.querySelector('.faq__answer');
            const icon = this.querySelector('.faq__icon');
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            
            faqQuestions.forEach(otherQuestion => {
                if (otherQuestion !== this) {
                    const otherItem = otherQuestion.closest('.faq__item');
                    const otherAnswer = otherItem.querySelector('.faq__answer');
                    const otherIcon = otherQuestion.querySelector('.faq__icon');
                    
                    otherItem.classList.remove('faq__item--active');
                    otherAnswer.style.maxHeight = null;
                    otherQuestion.setAttribute('aria-expanded', 'false');
                    otherIcon.textContent = '+';
                }
            });
            
            if (isExpanded) {
                item.classList.remove('faq__item--active');
                answer.style.maxHeight = null;
                this.setAttribute('aria-expanded', 'false');
                icon.textContent = '+';
            } else {
                item.classList.add('faq__item--active');
                answer.style.maxHeight = answer.scrollHeight + 'px';
                this.setAttribute('aria-expanded', 'true');
                icon.textContent = '-';
            }
        });
    });
}
